import { Box, Divider, Paper, Title, Flex, rem } from "@mantine/core";
import BackNavigationButton from "../../../../common/components/BackNavigationButton/BackNavigationButton";

const PlanFormPageShell = ({
  title,
  children,
  headerRight = null,
  headerTop = null,
  hideHeader = false,
 
  stickyHeader = false,
}) => {
  const headerSection = !hideHeader ? (
    <>
      <Flex
        align="center"
        justify="space-between"
        gap="sm"
        mt="md"
        mb="lg"
        px={{ base: 12, sm: 20, md: 28 }}
        style={stickyHeader ? { flexShrink: 0 } : undefined}
      >
        <Box style={{ flex: "0 0 40px", display: "flex", justifyContent: "flex-start" }}>
          <BackNavigationButton />
        </Box>
        <Title
          order={2}
          fz={24}
          fw={500}
          ff="Montserrat, sans-serif"
          c="#092C4C"
          ta="center"
          style={{ flex: 1, fontStyle: "normal" }}
          lineClamp={2}
        >
          {title}
        </Title>
        {headerRight ? (
          <Box style={{ flex: "0 0 auto", display: "flex", alignItems: "center" }}>
            {headerRight}
          </Box>
        ) : (
          <Box style={{ flex: "0 0 40px" }} aria-hidden />
        )}
      </Flex>

      <Divider
        size={2}
        styles={{
          root: {
            border: "none",
            height: 2,
            background: "linear-gradient(270deg, #0053A8 0%, #033F7C 100%)",
            borderRadius: 8,
            opacity: 0.15,
            marginLeft: rem(12),
            marginRight: rem(12),
            ...(stickyHeader ? { flexShrink: 0 } : {}),
          },
        }}
      />
    </>
  ) : null;

  return (
    <Paper
      radius={12}
      bg="#fff"
      shadow="sm"
      maw={1200}
      mx="auto"
      styles={{
        root: {
          border: "1px solid rgba(108, 148, 180, 0.12)",
          overflow: stickyHeader ? "hidden" : "visible",
          position: "static",
          ...(stickyHeader
            ? {
                display: "flex",
                flexDirection: "column",
                maxHeight: "calc(100dvh - 6rem)",
              }
            : {}),
        },
      }}
    >
      {headerTop ? (
        <Box
          px={{ base: 12, sm: 20, md: 28 }}
          pt="sm"
          pb={hideHeader ? 0 : 4}
          style={stickyHeader ? { flexShrink: 0 } : undefined}
        >
          {headerTop}
        </Box>
      ) : null}
      {headerSection}
      <Box
        px={{ base: 8, sm: 16, md: 24 }}
        pb="xl"
        pt={hideHeader ? "lg" : "md"}
        style={
          stickyHeader
            ? {
                flex: 1,
                minHeight: 0,
                minWidth: 0,
                maxWidth: "100%",
                overflowY: "auto",
                overflowX: "auto",
              }
            : { minWidth: 0, maxWidth: "100%", overflowX: "auto" }
        }
      >
        {children}
      </Box>
    </Paper>
  );
};

export default PlanFormPageShell;